module.exports = __webpack_public_path__ + "static/the-fall-of-constantinople-1453-a0565a0ca22c6724073d984a173e19a3.jpg";